import Vue from 'vue'
import Router from 'vue-router'
import AHnav from './components/Assistenzhunde/nav.vue'
import AHmain from './components/Assistenzhunde/main.vue'
import ASSnav from './components/Ausstellung/nav.vue'
import ASSmain from './components/Ausstellung/main.vue'
import STnav from './components/StoryAtelier/nav.vue'
import STmain from './components/StoryAtelier/main.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/assistenzhunde' },
    {
      path: '/assistenzhunde',
      name: 'assistenzhunde',
      components: {
        nav: AHnav,
        main: AHmain
      }
    },
    {
      path: '/story-atelier',
      name: 'story-atelier',
      components: {
        nav: STnav,
        main: STmain
      }
    },
    {
      path: '/ausstellung',
      name: 'ausstellung',
      components: {
        nav: ASSnav,
        main: ASSmain
      }
    }
  ]
})
